import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class HornedCorpse extends OrganicMobCorpse {
	static key = "HornedCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): HornedCorpse {
		const c = new HornedCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
